import React from "react";
import { map, size } from "lodash";
import styled from "styled-components";
import { FontSize, FontWeight, Spacing, content } from "@glossy";
import Button from "@ui-kit/button";
import { Label } from "@ui-kit/form";

type Item = {
  value: string;
  label?: string;
};

export interface IProps {
  title: string;
  sections: {
    title?: string;
    values: Item[];
  }[];
  renderItem: (
    single: boolean,
    value: Item,
    selected: string,
    index?: number
  ) => React.ReactNode;
  selected?: string;
  onClickBack: () => void;
  globalSections?: React.ReactNode;
}

const Root = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

const Header = styled.div`
  flex: 0;
  display: flex;
  align-items: center;
  padding: ${Spacing.Large} ${Spacing.ExtraLarge};
  border-bottom: 1px solid ${(props) => content(props, "tertiary")};
`;

const Title = styled.span`
  margin-left: ${Spacing.ExtraSmall};
  color: ${content};
  font-size: ${FontSize.Large};
  font-weight: ${FontWeight.Normal};
`;

const Body = styled.div`
  padding: ${Spacing.Medium} ${Spacing.ExtraLarge};
  overflow: auto;
`;

const StyledSection = styled.div`
  & + & {
    margin-top: ${Spacing.Large};
  }
`;

const StyledLabel = styled(Label)`
  margin-bottom: 6px;
  font-weight: ${FontWeight.Normal};
`;

const Group = styled.div<{ single: boolean }>`
  display: flex;
  flex-wrap: wrap;
  column-gap: ${Spacing.Medium};
  row-gap: ${(props) => (props.single ? Spacing.Large : Spacing.Medium)};
`;

const PanelsCardEditionChartSelector = ({
  title,
  sections,
  renderItem,
  selected,
  onClickBack,
  globalSections,
}: IProps) => {
  const single = size(sections) === 1;
  return (
    <Root>
      <Header>
        <Button icon="arrow-left" variant="tertiary" onClick={onClickBack} />
        <Title>{title}</Title>
      </Header>
      <Body>
        {globalSections}
        {map(sections, ({ title, values }, k) => (
          <StyledSection key={k}>
            {!single && <StyledLabel>{title}</StyledLabel>}
            <Group single={single}>
              {map(values, (item, i) => renderItem(single, item, selected, i))}
            </Group>
          </StyledSection>
        ))}
      </Body>
    </Root>
  );
};

export default PanelsCardEditionChartSelector;
